import { WebSocketClientMessageTypes } from './messageTypes';
import { WebSocketClientSubscription } from './subscriptionType';

export interface WebSocketClientState {
  subscriptionIdsByMessageType: Map<WebSocketClientMessageTypes, string[]>;
  subscriptions: Map<string, WebSocketClientSubscription>;
}

export enum WebSocketClientActionTypes {
  ADD_SUBSCRIPTION,
  REMOVE_SUBSCRIPTION,
  ON_MESSAGE_RECEIVED,
}

interface WebSocketClientActionPayload {
  type: WebSocketClientActionTypes;
  payload: any;
}

export const initialState: WebSocketClientState = {
  subscriptionIdsByMessageType: new Map(),
  subscriptions: new Map(),
};

export function addSubscriptionAction(
  subscription: WebSocketClientSubscription
) {
  return {
    type: WebSocketClientActionTypes.ADD_SUBSCRIPTION,
    payload: subscription,
  };
}

export function removeSubscriptionAction(subscriptionId: string) {
  return {
    type: WebSocketClientActionTypes.REMOVE_SUBSCRIPTION,
    payload: subscriptionId,
  };
}

export function onMessageReceivedAction(
  webSocketClientMessageType: WebSocketClientMessageTypes,
  message: any
) {
  return {
    type: WebSocketClientActionTypes.ON_MESSAGE_RECEIVED,
    payload: { webSocketClientMessageType, message },
  };
}

export function reducer(
  state: WebSocketClientState,
  action: WebSocketClientActionPayload
): WebSocketClientState {
  switch (action.type) {
    case WebSocketClientActionTypes.ADD_SUBSCRIPTION: {
      const { id, webSocketClientMessageType, callback } = action.payload;
      const subscriptions = new Map(state.subscriptions);
      const subscriptionIdsByMessageType = new Map(
        state.subscriptionIdsByMessageType
      );
      const newSubscription = { id, webSocketClientMessageType, callback };
      subscriptions.set(id, newSubscription);
      const subscriptionIds =
        subscriptionIdsByMessageType.get(webSocketClientMessageType) || [];
      subscriptionIds.push(id);
      subscriptionIdsByMessageType.set(
        webSocketClientMessageType,
        subscriptionIds
      );
      return { ...state, subscriptions, subscriptionIdsByMessageType };
    }
    case WebSocketClientActionTypes.REMOVE_SUBSCRIPTION: {
      if (!state.subscriptions.get(action.payload)) return { ...state };

      const subscriptions = new Map(state.subscriptions);
      const subscriptionIdsByMessageType = new Map(
        state.subscriptionIdsByMessageType
      );
      const subscription = subscriptions.get(action.payload)!;
      subscriptions.delete(action.payload);
      const subscriptionIds =
        subscriptionIdsByMessageType.get(
          subscription.webSocketClientMessageType
        ) || [];
      const index = subscriptionIds.indexOf(action.payload);
      if (index > -1) {
        subscriptionIds.splice(index, 1);
      }
      subscriptionIdsByMessageType.set(
        subscription.webSocketClientMessageType,
        subscriptionIds
      );
      return { ...state, subscriptions, subscriptionIdsByMessageType };
    }
    case WebSocketClientActionTypes.ON_MESSAGE_RECEIVED: {
      onNewWebSocketMessageReceived(
        state,
        action.payload.webSocketClientMessageType,
        action.payload.message
      );
      return { ...state };
    }
    default:
      return state;
  }
}

function onNewWebSocketMessageReceived(
  state: WebSocketClientState,
  webSocketClientMessageType: WebSocketClientMessageTypes,
  message: any
) {
  const subscriptionIds =
    state.subscriptionIdsByMessageType.get(webSocketClientMessageType) || [];
  subscriptionIds.forEach((id) => {
    const subscription = state.subscriptions.get(id)!;
    console.log(`### Received message for ${subscription.id} ###`);
    // Time out is to simulate a delay in the callback and prevent the UI from updating too fast
    setTimeout(() => {
      subscription.callback(message);
    }, 150);
  });
}
